import "./host-styles.css";
import * as panel from "./panel.js";

const HOST_BUTTON_SELECTOR = "#btnFreeTrialCustom";

window.TryProtege = { open: panel.open, close: panel.close };

document.addEventListener("click", (event) => {
  const trigger = event.target.closest(HOST_BUTTON_SELECTOR);
  if (!trigger) return;
  event.preventDefault();
  panel.open(trigger);
});